import { StudentHelperService } from '../../service/student-helper.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { Msg } from 'src/app/component/auth/model/user.model';
import { PCMEditInterface } from 'src/app/component/common-components/model/pcm-edit-interfacte';
import { PartyContactMechanisms } from 'src/app/component/party/model/party-contact-mechanisms.model';
import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { SearchStudent } from '../../model/searchStudent';
import { StudentService } from '../../service/student.service';
import { Student } from 'src/app/model/student/student.model';
import { CoeRelatedStudent } from 'src/app/component/common-components/multi-select-coe-student/coe-related-student';

@Component({
    selector: 'address-info',
    templateUrl: './address-info.component.html',
    styleUrls: ['./address-info.component.scss']
})
export class EditChildAddressInfoComponent implements OnInit {
    @Input() editing: boolean;
    @Output() editingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    partyContactMechanisms: PartyContactMechanisms[] = [];
    lstRemovedPcm: PartyContactMechanisms[] = [];
    lstEditedPcm: PartyContactMechanisms[] = [];
    student: Student;
    studentId!: number;
    partyId!: number;
    isSaving: boolean = false;
    msg: Msg = new Msg();

    subs: Subscription[] = [];
    coeRelatedStudents: CoeRelatedStudent[] = [];

    constructor(public apiSchoolService: ApiSchoolsService, public studentService: StudentService, private studentHelper: StudentHelperService) {
        this.subscriptions();
    }

    subscriptions() {
        let studentSub = this.studentHelper.student$.subscribe((student) => {
            this.student = student;

            if (this.student.ID) {
                this.studentId = this.student.ID!;
                this.partyId = this.student.PERSON.PARTy?.ID!;
                this.getCoeRelatedStudents();
                this.getPartyContactMechanisms(this.partyId);
            }
        });

        this.subs.push(studentSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnInit(): void {}

    getPartyContactMechanisms(PARTIES_ID: number) {
        this.apiSchoolService.getPartyContactMechanisms({ id: PARTIES_ID }).subscribe((x: any) => {
            this.partyContactMechanisms = x['partyContactMechanisms'] as PartyContactMechanisms[];
            this.notifyChildStatus();
        });
    }
    notifyChildStatus() {
        this.lstEditedPcm = [] = [];
        this.lstRemovedPcm = [] = [];
        let tempPartyContactMechanisms = [...this.partyContactMechanisms];
        this.partyContactMechanisms = [...tempPartyContactMechanisms];
    }

    pcmNotificationChange(event: PCMEditInterface, type: string) {
        switch (type) {
            case 'Address':
                if (event.deletePartyContactMechanisms != undefined && event.deletePartyContactMechanisms?.ID! >= 1)
                    this.lstRemovedPcm.push(event.deletePartyContactMechanisms);

                if (event.editpartyContactMechanisms != undefined && event.editpartyContactMechanisms.length >= 0) {
                    event.editpartyContactMechanisms.forEach((x) => this.lstEditedPcm.push(x));
                }
                break;
            case 'Phone':
                if (event.deletePartyContactMechanisms != undefined && event.deletePartyContactMechanisms.ID! >= 1)
                    this.lstRemovedPcm.push(event.deletePartyContactMechanisms);

                if (event.editpartyContactMechanisms != undefined && event.editpartyContactMechanisms.length >= 0) {
                    event.editpartyContactMechanisms.forEach((x) => this.lstEditedPcm.push(x));
                }
                break;
            default:
                break;
        }
    }

    isDisabled(): boolean {
        if (this.lstEditedPcm?.length > 0 || this.lstRemovedPcm?.length > 0) return false;
        else return true;
    }
    save() {
        let editUserPayload: any = {};
        this.isSaving = true;
        if (this.lstEditedPcm?.length > 0 || this.lstRemovedPcm?.length > 0) {
            editUserPayload = { editStudent: this.student, partyContactMechanisms: this.lstEditedPcm, deletePartyContactMechanisms: this.lstRemovedPcm };            
            this.studentService.updateStudentContactInformation(editUserPayload).subscribe((x: any) => {
                this.isSaving = false;
                if (x['msg'] !== undefined) {
                    this.msg = x['msg'];
                    if (this.msg.SUCCESS) {
                        this.editing = false;
                        this.editingChange.emit(this.editing);
                        this.getPartyContactMechanisms(this.partyId);
                        this.notifyChildStatus();
                    }
                }
            });
        }

        const s = timer(5000);
        s.subscribe((val) => {
            this.msg = new Msg();
        });
    }

    reset() {
        this.msg = new Msg();
        this.lstEditedPcm = [] = [];
        this.lstRemovedPcm = [] = [];
        let tempPartyContactMechanisms = [...this.partyContactMechanisms];
        this.partyContactMechanisms = [...tempPartyContactMechanisms];
    }

    getCoeRelatedStudents() {
        let coeRelatedStudentPayload: any = { party: { ID: this.partyId } };

        this.studentService.getCoeRelatedStudents(coeRelatedStudentPayload).subscribe((x) => {
            if (x['coes'] === undefined) {
                if (x['msg'] !== undefined) {
                    this.coeRelatedStudents = [];
                }
            } else {
                this.coeRelatedStudents = JSON.parse(x['coes']);
            }
        });
    }
}
